import axiosInstance from './axios';

export interface User {
    id: string;
    nombre: string;
    email: string;
    rol: 'SUPERADMIN' | 'ADMIN' | 'OPERADOR';
    empresa?: string;
    telefono?: string;
    status: 'ACTIVO' | 'INACTIVO';
    ultimoAcceso?: string;
    sedeId?: string | null;
    sede?: { id: string; nombre: string } | null;
}

export interface CreateUserData {
    nombre: string;
    email: string;
    password?: string;
    rol: 'ADMIN' | 'OPERADOR';
    telefono?: string;
    companyId?: string;
    /** Sede del operador (obligatoria si la empresa tiene varias) */
    sedeId?: string;
}

export const getUsers = async (): Promise<User[]> => {
    const response = await axiosInstance.get<User[]>('/users');
    return response.data;
};

export const createUser = async (data: CreateUserData): Promise<User> => {
    const response = await axiosInstance.post<User>('/users', data);
    return response.data;
};

export const deleteUser = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/users/${id}`);
};

export const updateUser = async (id: string, data: Partial<CreateUserData>): Promise<User> => {
    const response = await axiosInstance.patch<User>(`/users/${id}`, data);
    return response.data;
};
